// Brand
const Listbrand = () => import('@/views/campaign-management/brand/index')
const Formbrand = () => import('@/views/campaign-management/brand/form')

export default {
    path: 'brand',
    redirect: '/brand',
    component: {
        render(c) { return c('router-view') }
    },
    children: [{
            path: '/',
            name: 'brand',
            component: Listbrand,
            meta: {
                link: 'brand',
                breadcrumb: [
                    { title: 'Campaign Management', active: true },
                    { title: 'Brand', active: true },
                ],
                pageTitle: 'Brand'
            }
        },
        {
            path: 'add',
            name: 'addbrand',
            component: Formbrand,
            meta: {
                link: 'brand',
                breadcrumb: [
                    { title: 'Campaign Management', active: true },
                    { title: 'Brand', url: '/brand' },
                    { title: 'Create', active: true },
                ],
                pageTitle: 'Create Brand'
            }
        },
        {
            path: 'edit/:id',
            name: 'editbrand',
            component: Formbrand,
            meta: {
                link: 'brand',
                breadcrumb: [
                    { title: 'Campaign Management', active: true },
                    { title: 'Brand', url: '/brand' },
                    { title: 'Edit', active: true },
                ],
                pageTitle: 'Edit Brand'
            }
        },
    ]
}